module.exports = __webpack_public_path__ + "static/images/logo-full.20c75d3e8b736811f348281ee7ee3b56.svg";